import { Observable } from "rxjs";
import { CalendarGetQuery, CalendarGetQueryResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export interface ICalendarApiService {
  calendarGet(query: CalendarGetQuery): Observable<CalendarGetQueryResult>;

}


/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ICalendarApiServiceToken = new InjectionToken<ICalendarApiService>('ICalendarApiServiceToken');
